<app-titolo-subtitolo
  [titolo]="'Piano di Sostenibilità'"
  [paddingTop]="10"
  [isArchiviato]="isArchiviato()"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper
    [linear]="!isPubblicato() && !isArchiviato()"
    #stepper
    (selectionChange)="cambioStep($event)"
  >
    <mat-step [stepControl]="formPianoSostenibilita" [editable]="true">
      <ng-scrollbar [visibility]="'hover'">
        <ng-template matStepLabel> Piano di sostenibilità </ng-template>

        <form
          [formGroup]="formPianoSostenibilita"
          [alignItems]="'flex-start'"
          appFormContainer
          [larghezza]="12"
          [gap]="10"
          [rowGap]="5"
          style="align-items: center"
        >
          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">Creazione Piano di Sostenibilità</div>

            <div class="descrizione-sezione-dialog">
              Seleziona l'anno e scegli tra l'approccio generico e quello settoriale. Se selezioni
              l'approccio settoriale il sistema elaborerà un framework basato sulle specificità del
              settore di appartenenza. <br />
              La scelta del sotto-settore aumenterà l'accuratezza dell'approccio selezionato.
            </div>
          </div>

          <div style="display: flex; flex-direction: column; flex: none; padding-right: 15px">
            <mat-label>Framework</mat-label>
            <mat-radio-group
              class="radio-tipo-sett"
              aria-label="Framework"
              formControlName="tipoSettore"
            >
              <div class="radio-container">
                <mat-radio-button
                  aria-label="Generico"
                  value="GENERALE"
                  [disabled]="this.formPianoSostenibilita.get('id')?.value || !this.settoreGenerale"
                >
                  Generale
                </mat-radio-button>
                <div class="eti-check">
                  <mat-icon matTooltip="Adatto ad aziende di ogni settore" class="info-icon">
                    info_outline
                  </mat-icon>
                </div>
              </div>

              <div class="radio-container">
                <mat-radio-button
                  aria-label="Specifico"
                  value="SPECIFICO"
                  [disabled]="
                    this.formPianoSostenibilita.get('id')?.value || !this.settoriAzienda.length
                  "
                >
                  Settoriale
                </mat-radio-button>
                @if (!this.formPianoSostenibilita.get('id')?.value && !this.settoriAzienda.length) {
                  <div class="eti-check">
                    <mat-icon matTooltip="Estensione settoriale non attiva" class="info-icon">
                      info_outline
                    </mat-icon>
                  </div>
                } @else {
                  <div class="eti-check">
                    <mat-icon
                      matTooltip="Sviluppato ad hoc per il settore di appartenenza dell'azienda"
                      class="info-icon"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                }
              </div>
            </mat-radio-group>
          </div>

          <mat-form-field appFormElement [larghezza]="2">
            <mat-label>Anno</mat-label>
            <mat-select formControlName="anno" placeholder="Anno">
              <mat-option
                *ngFor="let anno of arrayAnni"
                [value]="anno"
                [disabled]="ctrAnnoPianoUtilizzata(anno)"
                >{{ anno }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="2"
            class="input-form"
            [riempi]="true"
            *ngIf="this.formPianoSostenibilita.get('tipoSettore')?.value === 'SPECIFICO'"
          >
            <mat-label>Settore</mat-label>
            <mat-select formControlName="settori" placeholder="Settore" [compareWith]="compareById">
              <mat-option
                *ngFor="let set of settoriAzienda"
                [value]="set"
                [disabled]="ctrSettorePianoUtilizzata(set)"
                >{{ set.titolo }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="5"
            class="input-form"
            *ngIf="
              this.formPianoSostenibilita.get('tipoSettore')?.value === 'SPECIFICO' &&
              arraySottoSettori?.length
            "
          >
            <mat-label>Sotto-settori</mat-label>
            <mat-select
              formControlName="sottoSettori"
              placeholder="Sotto-settori"
              [compareWith]="compareById"
              multiple
            >
              <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
                sottoSet.titolo
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="separatore" appFormElement [larghezza]="12">
            <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
          </div>

          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">
              Non partire da zero, lega la tua Piano ad altre attività
            </div>

            <div class="descrizione-sezione-dialog">
              Collegando altri moduli al piano di sostenibilità potrai utilizzare le informazioni
              inserite precedentemente. Selezionare l'Analisi di Materialità avrà un impatto sulla
              scelta delle tematiche di sostenibilità da sviluppare.
            </div>
          </div>

          <app-inclusione-moduli
            [annoModulo]="this.formPianoSostenibilita.get('anno')?.value"
            [idModulo]="this.formPianoSostenibilita.get('id')?.value"
            [settore]="this.formPianoSostenibilita.get('settori')?.value"
            [sottoSettore]="this.formPianoSostenibilita.get('sottoSettori')?.value"
            [tipoModulo]="'PIANO'"
            [idModuiliInclusi]="idModuliInclusi"
          ></app-inclusione-moduli>
        </form>
      </ng-scrollbar>
    </mat-step>

    <!-- SELEZIONE TEMATICHE   -->
    <mat-step [editable]="true" errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Tematiche </ng-template>

      <app-cfg-questionario
        #surveyComp
        [isPermessoSoloRead]="isPermessoSoloRead"
        [tipoQuestionario]="'PIANO'"
        [cfgQuestionario]="piano"
        [idSostenibilita]="formPianoSostenibilita.get('id')?.value"
        [nascondiTitolo]="true"
      ></app-cfg-questionario>
    </mat-step>
    <!--  ---------------------- O B I E T T I V I ---------- -->
    <mat-step>
      <ng-template matStepLabel> Obiettivi </ng-template>
      <div appFormContainer [larghezza]="2" style="align-items: center">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione degli Obiettivi</div>
          <div class="descrizione-sezione-dialog">
            Gli obiettivi rappresentano le priorità aziendali legate alle tematiche di sostenibilità
            per migliorare le performance di sostenibilità dell'azienda.<br />
            Seleziona almeno un obiettivo per tematica: questi saranno alla base della definizione
            di target specifici e misurabili.
          </div>
        </div>
      </div>

      <app-selezione-obiettivi-piano
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioObiettivi"
        chiaveElemento="elementi"
        [idContest]="this.formPianoSostenibilita.get('id')?.value"
        [stato]="piano?.stato"
        chiaveElementoSelezione="obiettivo"
      >
      </app-selezione-obiettivi-piano>
    </mat-step>

    <!--  ---------------------- T A R G E T ---------- -->
    <mat-step>
      <ng-template matStepLabel> Target </ng-template>
      <div appFormContainer [larghezza]="2" style="align-items: center">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Lega i Target ai tuoi Obiettivi</div>
          <div class="descrizione-sezione-dialog">
            Per ognuno degli obiettivi, seleziona almeno un target qualitativo o quantitativo che
            l'azienda intende raggiungere in futuro.
          </div>
        </div>
      </div>

      <ng-scrollbar>
        <div style="padding-right: 20px">
          <app-lista-tabellare
            #tabellaTarget
            [fnCaricamentoDati]="fnCaricamentoDatiTarget"
            [colonne]="colonneTarget"
            [maxNrButton]="1"
            [isFiltri]="false"
            [fnCaricamentoStyle]="fnCaricamentoStyleTargetBlack"
            (bottoniListaClick)="bottoniListaClickTarget($event)"
          >
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
      <ng-container *ngIf="isTargetNonCompletto">
        <div class="info-risposta">
          <span class="material-icons icone-tem icone-label-chack info-icon"> info </span>
          <mat-label class="risposta-read-only" appFormElement [larghezza]="3" [riempi]="true">
            Attenzione: definire almeno un target per ognuno degli obiettivi selezionati
          </mat-label>
        </div>
      </ng-container>
    </mat-step>

    <!--  ---------------------- C R U S C O T T O ---------- -->
    <mat-step>
      <ng-template matStepLabel> Cruscotto </ng-template>
      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">Cruscotto Piano di Sostenibilità</div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>

        <!-- TOTALI CRUSCOTTO -->
        @if (this.formPianoSostenibilita.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscotto
            [idModulo]="this.formPianoSostenibilita.get('id')?.value"
            [tipoModulo]="'PIANO'"
          >
          </app-totali-cruscotto>
        }

        <!-- <div class="contatori">
          <div style="text-align: center">
            <div class="titolo-cont">T. QUALITATIVI</div>
            <div class="contatore">
              <div class="dato">
                <div class="valore" style="font-size: 24px; color: #729373">
                  {{ tQualitativiCompilati }}
                </div>
                <div class="label">compilati</div>
              </div>
              <div class="verticale"></div>
              <div class="dato">
                <div class="valore" style="font-size: 24px; color: #cf5b61">
                  {{ tQualitativiNonCompilati }}
                </div>
                <div class="label">non compilati</div>
              </div>
            </div>
          </div>

          <div style="text-align: center">
            <div class="titolo-cont">T. QUANTITATIVI</div>
            <div class="contatore">
              <div class="dato">
                <div class="valore" style="font-size: 24px; color: #729373">
                  {{ tQuantitativiCompilati }}
                </div>
                <div class="label">compilati</div>
              </div>
              <div class="verticale"></div>
              <div class="dato">
                <div class="valore" style="font-size: 24px; color: #cf5b61">
                  {{ tQuantitativiNonCompilati }}
                </div>
                <div class="label">non compilati</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <ng-scrollbar>
        <div style="padding-right: 15px">
          <app-lista-tabellare
            #tabellaCruscotto
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDatiCruscotto"
            [colonne]="colonneCruscotto"
            [maxNrButton]="1"
            [filtri]="filtriCruscotto"
            (bottoniListaClick)="bottoniListaClickCruscotto($event)"
            *ngIf="this.formPianoSostenibilita.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="template()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isArchiviato()"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTutti()"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isArchiviato()"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTutti()"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>
    <!--  ---------------------- D O C U M E N T O  --------- -->
    <mat-step>
      <ng-template matStepLabel> Documento </ng-template>

      <mat-tab-group class="mat-tab-group-documento">
        <mat-tab label="Indirizzi strategici e sostenibilità">
          <div appFormContainer [larghezza]="2" style="align-items: center; padding-top: 20px">
            <div appFormElement [larghezza]="1" [riempi]="true">
              <div class="titolo-sezione-dialog">Indirizzi strategici e sostenibilità</div>
              <div class="descrizione-sezione-dialog">
                Descrivi la tua strategia di sostenibilità e come questa trovi applicazione nel
                Piano di Sostenibilità. Delinea la struttura del Piano e della governance di
                sostenibilità.<br />
                La linea guida presente nel campo fornisce un esempio dettagliato.
              </div>
            </div>
          </div>
          <div class="paragrafo" style="flex: 1" *ngIf="objDocumento">
            <app-editor
              [disabled]="isPermessoSoloRead"
              [(ngModel)]="objDocumento.scritturaDocumento"
            ></app-editor>
          </div>
        </mat-tab>

        <mat-tab label="Finalità del Piano">
          <div
            appFormContainer
            [larghezza]="2"
            style="align-items: center; padding-top: 15px; padding-bottom: 10px"
          >
            <div appFormElement [larghezza]="1" [riempi]="true">
              <div class="titolo-sezione-dialog">
                Selezione delle Finalità del Piano di Sostenibilità
              </div>
              <div class="descrizione-sezione-dialog">
                Tramite il Piano di Sostenibilità le aziende definiscono una strategia futura per
                raggiungere determinate finalità strategiche connesse alla sostenibilità e agli
                impegni assunti in altri documenti aziendali, come ad esempio la Policy di
                Sostenibilità. <br />
                Seleziona le finalità della strategia di sostenibilità aziendale che trovano
                attuazione nel Piano.
              </div>
            </div>
          </div>

          <div class="cont-titolo">
            <mat-label class="titolo"
              >Selezione delle Finalità del Piano di Sostenibilità</mat-label
            >
          </div>
          <div style="flex: 1; padding: 10px 0 10px 10px">
            <ng-scrollbar>
              <div
                appFormContainer
                [larghezza]="3"
                *ngFor="let elemento of objDocumento?.obiettiviAziendaliPiano"
              >
                <div appFormElement [larghezza]="0.7" [riempi]="true">
                  <mat-checkbox
                    [disabled]="isPermessoSoloRead"
                    [(ngModel)]="elemento.selected"
                    [checked]="elemento.selected"
                    (mousedown)="$event.stopPropagation()"
                    color="primary"
                  >
                    <div class="nome-figura">{{ elemento.descrizione }}</div>
                  </mat-checkbox>
                </div>

                <button
                  class="icone-button"
                  mat-icon-button
                  (click)="modificaObiettivoAziendale(elemento); $event.stopPropagation()"
                  [title]="isPermessoSoloRead ? 'Visualizza' : 'Compila'"
                  [attr.aria-label]="isPermessoSoloRead ? 'Visualizza' : 'Compila'"
                >
                  <mat-icon class="icone">
                    {{ isPermessoSoloRead ? 'visibility' : 'edit' }}
                  </mat-icon>
                </button>
              </div>
            </ng-scrollbar>
          </div>
          <div class="btn-aggiungi-nuovo">
            <button
              [disabled]="isPermessoSoloRead"
              mat-stroked-button
              (click)="modificaObiettivoAziendale()"
              style="height: 40px; width: 95%; font-weight: bold; background-color: #f5f5f5"
            >
              + Aggiungi Selezione delle Finalità del Piano di Sostenibilità
            </button>
          </div>
        </mat-tab>
        <mat-tab label="Modello di Sviluppo Piano">
          <div
            appFormContainer
            [larghezza]="2"
            style="align-items: center; padding-top: 15px; padding-bottom: 10px"
          >
            <div appFormElement [larghezza]="1" [riempi]="true">
              <div class="titolo-sezione-dialog">
                Definizione del Modello di Sviluppo del Piano di Sostenibilità
              </div>
              <div class="descrizione-sezione-dialog">
                Il successo del Piano di Sostenibilità dipende da fattori strategici che l'azienda
                deve integrare e sviluppare per creare le condizioni necessarie per conseguire i
                target definiti.<br />
                Seleziona i fattori strategici su cui basare il piano e le strategie per la
                sostenibilità.
              </div>
            </div>
          </div>

          <div class="cont-titolo">
            <mat-label class="titolo">Modello di Sviluppo Piano</mat-label>
          </div>

          <div style="flex: 1; padding: 10px 0 10px 10px">
            <ng-scrollbar>
              <div
                appFormContainer
                [larghezza]="3"
                *ngFor="let elemento of objDocumento?.modelliSviluppoPiano"
              >
                <div appFormElement [larghezza]="0.7" [riempi]="true">
                  <mat-checkbox
                    [disabled]="isPermessoSoloRead"
                    [(ngModel)]="elemento.selected"
                    [checked]="elemento.selected"
                    (mousedown)="$event.stopPropagation()"
                    color="primary"
                  >
                    <div class="nome-figura">{{ elemento.descrizione }}</div>
                  </mat-checkbox>
                </div>

                <button
                  class="icone-button"
                  mat-icon-button
                  (click)="modificaModelloSviluppo(elemento); $event.stopPropagation()"
                  [title]="isPermessoSoloRead ? 'Visualizza' : 'Compila'"
                  [attr.aria-label]="isPermessoSoloRead ? 'Visualizza' : 'Compila'"
                >
                  <mat-icon class="icone">
                    {{ isPermessoSoloRead ? 'visibility' : 'edit' }}
                  </mat-icon>
                </button>
              </div>
            </ng-scrollbar>
          </div>
          <div class="btn-aggiungi-nuovo">
            <button
              [disabled]="isPermessoSoloRead"
              mat-stroked-button
              (click)="modificaModelloSviluppo()"
              style="height: 40px; width: 95%; font-weight: bold; background-color: #f5f5f5"
            >
              + Aggiungi Modelli di Sviluppo Piano
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-step>
  </mat-stepper>
</div>

<footer mat-dialog-actions class="dialog-footer-cont">
  <button
    mat-flat-button
    color="accent"
    [disabled]="stepper.selectedIndex === 0"
    (click)="indietro()"
    class="accent-button"
  >
    Indietro
  </button>

  <button
    mat-flat-button
    color="primary"
    (click)="avantiHTML()"
    class="primary-button"
    #btnAvanti
    *ngIf="stepper.selectedIndex !== 5"
  >
    Avanti
  </button>

  <button
    mat-flat-button
    color="primary"
    (click)="salvaDocumentoInHTML()"
    class="primary-button"
    *ngIf="stepper.selectedIndex === 5 && !isPermessoSoloRead"
  >
    Salva
  </button>
  <button
    mat-dialog-close
    mat-flat-button
    color="accent"
    class="accent-button"
    *ngIf="stepper.selectedIndex === 5 && isPermessoSoloRead"
  >
    Chiudi
  </button>

  <button
    *ngIf="stepper.selectedIndex === 3"
    mat-flat-button
    color="primary"
    (click)="assegnazioni()"
    class="primary-button"
  >
    <mat-icon>person_edit</mat-icon> Assegnazioni
  </button>

  <button
    *ngIf="stepper.selectedIndex === 5"
    mat-flat-button
    color="accent"
    (click)="stampa()"
    class="accent-button"
    style="margin-left: 10px !important"
  >
    <mat-icon class="material-icons-outlined"> print </mat-icon>Stampa
  </button>
</footer>
